import React from 'react';
import component, {classnames} from './../component';

import TournamentDetails from './TournamentDetails';
import TournamentGroupStage from './TournamentGroupStage';
import TournamentPlayOff from './TournamentPlayOff';

export default component('TournamentGroupStage', function({data, params}){

  const tournament = data.getIn(['tournamentData', parseInt(params.id)]);
  const stage = data.getIn(['stages', parseInt(params.stageId)]);

  if (!tournament) {
    return null;
  }

  let content = null;

  if (stage) {
    if (stage.get('type') === 'group') {
      content = <TournamentGroupStage stage={stage} data={data} params={params}/>;
    }
    if (stage.get('type') === 'single') {
      content = <TournamentPlayOff stage={stage} data={data} params={params} teamsAmount={128}/>;
    }
    if (stage.get('type') === 'double') {
      content = <TournamentPlayOff stage={stage} data={data} params={params} teamsAmount={128} losers={params.modificator === 'losers'}/>;
    }
  }

  return (
    <TournamentDetails content={content} data={data} params={params}/>
  );
});



// WEBPACK FOOTER //
// ./src/components/pages/TournamentStage.js